module.exports = __webpack_public_path__ + "static/media/right.570533e0.svg";